module.exports = __webpack_public_path__ + "static/img/title.2d0d92b.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/news2/title.png
// module id = QywU
// module chunks = 7